import { env } from '@/shared/config';
import { Button } from '@/shared/ui/button/Button';

import styles from './ErrorScreen.module.scss';

interface ErrorScreenProps {
  title?: string;
  message?: string;
  /**
   * Текст ошибки. Показывается только в dev: игроку он ничего не говорит.
   * `| undefined` обязателен — включён `exactOptionalPropertyTypes`,
   * и без него нельзя передать проп, который может оказаться undefined.
   */
  detail?: string | undefined;
  actionLabel?: string;
  onAction: () => void;
}

export function ErrorScreen({
  title = 'Что-то сломалось',
  message = 'Мы уже знаем о проблеме. Попробуй открыть игру заново.',
  detail,
  actionLabel = 'Перезагрузить',
  onAction,
}: ErrorScreenProps) {
  return (
    <div className={styles.wrapper} data-testid="error-screen" role="alert">
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.message}>{message}</p>

      {env.isDev && detail ? (
        <pre className={styles.detail} data-testid="error-detail">
          {detail}
        </pre>
      ) : null}

      <Button onClick={onAction}>{actionLabel}</Button>
    </div>
  );
}
